module.exports = __webpack_public_path__ + "img/comment-middle-top.5b682dfc.svg";